export default __webpack_public_path__ + "static/media/korea-circle-flag.aa363943.png";